import React from 'react';

export type CircularProgressIconProps =
  React.ReactComponentElement<'svg'>['props'] & {
    progressPercent: number;
    duration: number;
  };
export function CircularProgressIcon({
  progressPercent,
  duration,
  ...props
}: CircularProgressIconProps) {
  const offet = ((100 - progressPercent) / 100) * 290;
  return (
    <svg viewBox="0 0 100 100" {...props}>
      <path
        d="M50 4a46 46 0 110 92 46 46 0 110-92"
        fillOpacity="0"
        stroke="#4f5794"
        strokeDasharray="290px 290px"
        strokeDashoffset="0"
        strokeWidth="4"
      />
      <path
        className="transition-[stroke-dashoffset] ease-linear"
        d="M50 4a46 46 0 110 92 46 46 0 110-92"
        fillOpacity="0"
        stroke="url(#linear)"
        strokeDasharray="290px 290px"
        strokeDashoffset={offet}
        strokeWidth="4"
        style={{ transitionDuration: `${duration}ms` }}
      />
      <svg height={0} width={0}>
        <defs>
          <linearGradient id="linear" x1="0%" x2="100%" y1="0%" y2="0%">
            <stop offset="0%" stopColor="#ffdd4f" />
            <stop offset="100%" stopColor="#f78600" />
          </linearGradient>
        </defs>
      </svg>
    </svg>
  );
}
